import { ErrorHandler, Injectable } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
  constructor() {}

  handleError(error: Error): void {
    // eslint-disable-next-line no-console
    console.error('error', error);
    datadogLogs.logger.error(error.message, error);
  }
}
